export default {
    about: 'about',
    home: 'home',
    message_desk: 'Discuss via SMS with our regional contact'
}
